import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import $ from "jquery";
// type StocksByGenre = {
//   [jenre: string]: {
//     [flavorBrandId: string]: {
//       productRecord: kintone.myApp.SavedProduct;
//       flavorBrand: kintone.myApp.SavedFlavorBrand;
//     }[];
//   };
// };
const trans = {
    ja: {
        error: "エラーが発生しました。再度お試しください",
        loading: "データ取得中...",
        selectBrand: "ブランドを選択",
        selectGenre: "ジャンルを選択",
        outOfStock: "在庫切れ",
    },
    en: {
        error: "An error has occurred. Please try again.",
        loading: "Fetching Data...",
        selectBrand: "Select Brand",
        selectGenre: "Select Genre",
        outOfStock: "Out of stock",
    },
};
const genre_en = {
    "01_フルーツ系": "Fruity",
    "02_お菓子系": "Sweets",
    "03_フローラル系": "Floral",
    "04_スパイス・ハーブ系": "Spicy, herbs",
    "05_紅茶・カクテル系": "Tea, Cocktail",
};
const Component = (props) => (React.createElement(Fragment, null, props.error ? (React.createElement("div", null, trans[props.lang]["error"])) : props.loading ? (React.createElement("div", null, trans[props.lang]["loading"])) : (React.createElement(Fragment, null,
    props.type === "brand" ? (React.createElement("div", { className: "content__innerbox--select" },
        React.createElement("select", { id: "SelectBrand", name: "brand", onChange: () => {
                const brand = $("select[name='brand'] option:selected").val();
                $(".brand__li").not(`#${brand}`).hide(500);
                $(`#${brand}`).show(500);
            } },
            React.createElement("option", { value: "none" }, trans[props.lang]["selectBrand"]),
            Object.keys(props.stocksByBrand).map((brandId) => (React.createElement("option", { key: `option-${brandId}`, value: props.stocksByBrand[brandId].flavorBrand.name.value.toLowerCase().replaceAll(" ", "_") }, props.stocksByBrand[brandId].flavorBrand.name.value)))))) : (React.createElement("div", { className: "content__innerbox--select" },
        React.createElement("select", { id: "SelectGenre", name: "genre", onChange: () => {
                const genre = $("select[name='genre'] option:selected").val();
                $(".brand__li").hide();
                $(`.${genre}`).parents(".brand__li").show();
                $(".genre-list li").not(`.${genre}`).hide(500);
                $(`.${genre}`).show(500);
            } },
            React.createElement("option", { value: "none" }, trans[props.lang]["selectGenre"]),
            [
                ...new Set(Object.values(props.stocksByBrand)
                    .flatMap(({ productRecords }) => productRecords.map((p) => p.flavor_jenre.value))
                    .sort()
                    .filter((g) => g)),
            ].map((genre) => (React.createElement("option", { key: `option-${genre}`, value: genre.replaceAll(" ", "_") }, props.lang === "en" ? genre_en[genre] : genre.split("_")[1])))))),
    React.createElement("ul", { className: "brand" }, Object.keys(props.stocksByBrand).map((brandId) => (React.createElement("li", { key: brandId, id: props.stocksByBrand[brandId].flavorBrand.name.value.toLowerCase().replace(" ", "_"), className: "brand__li" },
        React.createElement("div", { className: "brand__li--leftbox" },
            React.createElement("div", { className: "brand__li--pict" },
                React.createElement("img", { src: props.stocksByBrand[brandId].flavorBrand.logo_img_url.value, alt: "" })),
            React.createElement("div", { className: "brand__li--name" },
                React.createElement("b", null, props.stocksByBrand[brandId].flavorBrand.name.value)),
            React.createElement("div", { className: "brand__li--desc" }, (props.lang === "en"
                ? props.stocksByBrand[brandId].flavorBrand.description_en.value
                : props.stocksByBrand[brandId].flavorBrand.description.value).split("\n")
                // joinはReactNodeに対して使えないのでworkaround
                .reduce((prev, curr, i) => [prev, React.createElement("br", { key: i }), curr]))),
        React.createElement("div", { className: "brand__li--rightbox" },
            React.createElement("ul", { className: "genre-list" }, props.stocksByBrand[brandId].productRecords.map((p) => {
                var _a;
                return (React.createElement("li", { key: p.$id.value, className: (_a = p.flavor_jenre.value) === null || _a === void 0 ? void 0 : _a.replaceAll(" ", "_") },
                    p.name.value,
                    " ",
                    p.stock_status.value === "在庫切れ" && `(${trans[props.lang]["outOfStock"]})`));
            })))))))))));
const Container = (props) => {
    const [stocksByBrand, setStocksByBrand] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    console.log(stocksByBrand);
    useEffect(() => {
        (async () => {
            console.log("called");
            try {
                setError(false);
                setLoading(true);
                setStocksByBrand((await axios.get(`${process.env.MENU_PROXY_ENDPOINT}/main/flavors-by-brand?branch=${props.branch}`)).data);
            }
            catch (_a) {
                setError(true);
            }
            finally {
                setLoading(false);
            }
        })();
    }, [props.branch]);
    return React.createElement(Component, { ...props, stocksByBrand: stocksByBrand, loading: loading, error: error });
};
export default Container;
